module.exports = "/images/assistance.jpg?5995faaa2902d8ece4981e3368af724f";